import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { $accountForIntegrationsStore } from '@lib/store';
import type { IntegrationType } from '@shared/api/rest/integrations';
import type { AccountForIntegrationsRequest } from '@shared/api/rest/accounts';
import { NoData, PageContainer } from '@shared/widgets';
import { Accounts, IntegrationTitle } from './widgets';

export const IntegrationPage = () => {
  const params = useParams<{ id: IntegrationType }>();

  const [countItemPage, setCountItemPage] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currency, setCurrency] = useState<string>();

  useEffect(() => {
    const params: AccountForIntegrationsRequest = {
      Count: countItemPage,
      FromIndex: (currentPage - 1) * countItemPage,
      ReturnTotalCount: true,
      Currency: currency,
    };
    $accountForIntegrationsStore.events.getAccounts(params);
  }, [countItemPage, currentPage, currency]);

  return (
    <PageContainer title='Card' backText='Back to integrations'>
      {!params?.id ? (
        <NoData />
      ) : (
        <>
          <IntegrationTitle name={params.id} currency={currency} onChangeCurrency={setCurrency} />
          <Accounts
            integration={params.id}
            currency={currency}
            countItemPage={countItemPage}
            currentPage={currentPage}
            onChangeCountItemPage={setCountItemPage}
            onChangePage={setCurrentPage}
          />
        </>
      )}
    </PageContainer>
  );
};
